import { createSlice } from "@reduxjs/toolkit";
import { push } from "connected-react-router";
import { setErrorMessage } from "./errors";
import { mapErrorMessage, capitalize } from "../utils";
import api from "../api";

const initialState = {
  userValidated: false,
  addNewAddress: null,
  currentAddress: null,
  contactDetails: null,
  data: null,
};

/*
  createSlice uses immer to let you write reducers as if they were mutating
  the state directly.
  In reality, the reducer receives a proxy state that translates all mutations
  into equivalent copy operations
  https://redux-toolkit.js.org/api/createSlice
*/

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setValidatedUser(state, action) {
      return { ...state, userValidated: true, ...action.payload };
    },
    setUserData(state, action) {
      return { ...state, ...action.payload };
    },
    setAddNewAddress(state, action) {
      state.addNewAddress = action.payload;
    },
    setNewdAddress(state, action) {
      state.currentAddress = {
        ...state.currentAddress,
        ...action.payload,
      };
    },
    setContactDetails(state, action) {
      state.contactDetails = {
        ...state.contactDetails,
        ...action.payload,
      };
    },
  },
});

// Extract and export each action creator by name
export const {
  setValidatedUser,
  setUserData,
  setAddNewAddress,
  setNewdAddress,
  setContactDetails,
} = userSlice.actions;

// Define a thunk that dispatches those action creators
export const fetchUserAuth = (token) => async (dispatch) => {
  try {
    const { data } = await api.post(
      "/seguros/generar/token/validar",
      {
        token: token,
      }
    );
    if (data) {
      dispatch(setValidatedUser(data.data.pub));
    }
  } catch (error) {
    dispatch(setErrorMessage(mapErrorMessage("systemError")));
    dispatch(push("/error"));
  }
};

export const fetchUserData = () => async (dispatch, getState) => {
  try {
    const { auth, user } = getState();
    const { data } = await api.get(
      "/duc/ch/PDS",
      {
        headers: {
          Authorization: `Bearer ${auth.token}`,
        },
      }
    );

    if (data && data.customer) {
      const {
        basicIndividualData: { address: currentAddress },
        electronicsContact = {},
        contactCellphone = {},
      } = data.customer || {};

      const phone =
        contactCellphone.phoneNumber &&
        contactCellphone.phoneNumber
          .trim()
          .slice(-12)
          .replace("15", "11")
          .replace(/[-,(,)]/g, "");

      const phoneCompany =
        contactCellphone.smsProvider &&
        capitalize(contactCellphone.smsProvider);

      const email =
        electronicsContact.emailAddressComplete &&
        electronicsContact.emailAddressComplete.trim();

      const floor = currentAddress.floor.trim();
      const locality = currentAddress.locality;
      const provinceCode = currentAddress.provinceCode;
      const street = currentAddress.street;
      const streetNumber = currentAddress.streetNumber;
      const zipCode = currentAddress.zipCode;
      const areaPhone = currentAddress.areaPhone;

      dispatch(
        setUserData({
          currentAddress: {
            floor,
            locality,
            provinceCode,
            street,
            streetNumber,
            zipCode,
          },
          contactDetails: { email, phone, phoneCompany, areaPhone },
        })
      );
    }
  } catch (error) {
    dispatch(setErrorMessage(mapErrorMessage("systemError")));
    dispatch(push("/error"));
  }
};

// Export the reducer, either as a default or named export
export default userSlice.reducer;
